import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { interval, Observable, Subscription, switchMap } from 'rxjs';
import { UserToken } from 'src/app/core/auth.model';
//import { UserTokenService } from 'src/app/core/services/user-token.service';
import { AppComponent } from '../../app.component';
import { AppMainComponent } from '../../app.main.component';
import { UserTokenService } from 'src/app/core/services/user-token.service';
import { ScUserService } from 'src/app/core/services/sc/sc-user.service';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { ScUserMessageOutput } from 'src/app/models/response/sc-user.model';
import { OverlayPanel } from 'primeng/overlaypanel';

interface TableRowSelectEvent {
  originalEvent?: Event;
  data?: any;
  type?: string;
  index?: number;
}

@Component({
  selector: 'app-topbar',
  templateUrl: './app.topbar.component.html'
})
export class AppTopBarComponent implements OnInit, OnDestroy {

  user$: Observable<UserToken>;
  public logo: String = "";
  public hasLogo: boolean = false;
  public idUsuario: number;
  public companyName: String = "";
  currentUser!: UserToken;
  userAcronym!: string;
  readonly AVATAR_COLOR = '#ba40ef';

  isDesktop$!: Observable<boolean>;

  public listMessage: ScUserMessageOutput[] = [];
  selectedMessage: ScUserMessageOutput | undefined;
  message_confirm_reading!: string;
  azureRepoEndPoint!: string;
  processing: boolean = false;
  private subscription!: Subscription;
  startTimeMessage: number = 30000;

  constructor(public app: AppComponent,
    public appMain: AppMainComponent,
    private router: Router,
    private userTokenService: UserTokenService,
    private scUserService: ScUserService,
    private messageService: MessageService,
    private translateService: TranslateService,
    private userService: ScUserService) { }

  ngOnInit(): void {
    //TODO - Company Name and Logo - where to show?
    this.user$ = this.userTokenService.getUser();
    this.companyName = this.userTokenService.getCompanyName();
    //this.isDesktop$ = this.uiService.onDetectDevice(900);

    this.azureRepoEndPoint = this.userTokenService.getAzureRepoEndPoint();
    this.logo = this.userTokenService.getLogoUri();
    if (this.logo != "" || this.logo.length > 1)
      this.hasLogo = true;

    this.router.events.subscribe(event => {
      //console.log(event)
      if (event instanceof NavigationStart && !this.processing) {
        this.processing = true;

        
      }
    });

    // Configura o intervalo para verificar a API a cada 10 segundos
    this.subscription = interval(this.startTimeMessage) // 10.000 ms = 10 segundos
      .pipe
      (
      //switchMap(() => this.http.get('https://api.exemplo.com/weather')) // Substitua pela URL da sua API
    )
      .subscribe({
        next: (data) => {
          this.startTimeMessage = 30000; // Atualiza o tempo de espera para 30 segundos após a primeira execução
          //console.log('Mudou a rota!', event);        
          this.scUserService.getListUserMessageByUser()
            .subscribe(
              {
                next: (data) => {

                  let messages = data.data;
                  let listMessages = [];
                  if (messages.length > 0) {
                    let listMessageGroup = this.groupByUserMessage(messages, 'woOrderId');
                    //console.log(listMessageGroup);
                    listMessageGroup.forEach(element => {
                      listMessages = element.Elements;
                    });
                  }

                  listMessages.forEach(element => {
                    let severity = '';
                    if (element.isSendNotification) {
                      severity = 'success';
                    } else if (element.isError) {
                      severity = 'error';
                    } else {
                      severity = 'info';
                    }

                    this.messageService.add({ key: 'messages', severity: severity, summary: this.translateService.instant('message.new_message'), detail: element.message, life: 10000 });
                    element.isView = true;

                    //console.log(element);

                    if (element != null || element != undefined) {

                      this.scUserService.updUserMessage(element)
                        .subscribe(
                          {
                            next: (data) => {
                            },
                            error: (err) => {
                              console.log(`AppComponent - updUserMessage: ${err}.`);
                            }
                          });
                    }
                  });
                  this.processing = false;
                },
                error: (err) => {
                  console.log(`AppComponent - router.events.subscribe: ${err}.`);
                  this.processing = false;
                }
              });
          //console.log('Dados atualizados:', data);
        },
        error: (err) => console.error('Erro ao buscar dados:', err)
      });

    this.message_confirm_reading = this.translateService.instant('label.message_confirm_reading');

    this.getListUserMessage();

  }

  onGetUser(): void {
    this.userTokenService.getUser().subscribe({
      next: (response) => {
        if (response) {
          this.currentUser = response;

          const fullName = response.Given_name.split(' ')

          const firstName = fullName[0];
          const lastName = fullName[fullName.length - 1];

          const firstletter = firstName[0].toLocaleUpperCase();
          const lastletter = lastName[0].toLocaleUpperCase();

          this.userAcronym = `${firstletter}${lastletter}`;
        }
      },
      error: () => null
    });

  }

  getListUserMessage() {
    this.userService.getListUserMessage(`TargetUserId_SourceUserId = ${this.userTokenService.getUserId()}`).subscribe(
      {
        next: (res) => {
          let localMessages = [];
          if (res)
            this.listMessage = res.data.filter(f => f.isRead !== true).sort((a, b) => {
              return new Date(b.dateOfRegistration).getTime() - new Date(a.dateOfRegistration).getTime();
            });

          // if (localMessages.length > 0) {
          //   let listMessages = this.groupByUserMessage(localMessages, 'woOrderId');
          //   listMessages.forEach(element => {
          //     this.listMessage.push(element.Elements[0]);
          //   });
          // }
        },
        error: (err) => console.log(`AppTopBarComponent - getListUserMessage : ${err}.`)
      });
  }

  groupByUserMessage(colecao, propriedade) {
    var agrupado = [];
    colecao.forEach(function (i) {
      var foiAgrupado = false;
      agrupado.forEach(function (j) {
        if (j.Key == i[propriedade]) {
          j.Elements.push(i);
          foiAgrupado = true;
        }
      });
      if (!foiAgrupado) agrupado.push({ Key: i[propriedade], Elements: [i] });
    });
    return agrupado;
  }

  onRowSelect(event: any, op: OverlayPanel) {
    //this.messageService.add({ key:"messages", severity: 'info', summary: 'Messsage Selected', detail: event.data.name });
    //op.hide();
    event.data.isRead = true;
    this.scUserService.updUserMessage(event.data)
      .subscribe(
        {
          next: (data) => {
            this.getListUserMessage();
          },
          error: (err) => {
            console.log(`AppComponent - onRowSelect - updUserMessage: ${err}.`);
          }
        });
  }

  ngOnDestroy(): void {
    // Cancela a assinatura ao destruir o componente
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
